import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { create, windowScheduler } from "@yornaath/batshit";
import { Collections } from "@graylog/enterprise-api";
import { COLLECTIONS_QUERY_KEY } from "collections/hooks/useCollections";
const entityCollectionStatus = create({
  fetcher: (entityGRNs) => Collections.getStatuses({ entity_grns: entityGRNs }),
  resolver: (result) => result,
  scheduler: windowScheduler(10)
});
const keyFn = (entityGRN, id) => [COLLECTIONS_QUERY_KEY, "entity", entityGRN, id, "status"];
const fetchEntityCollectionStatus = async (entityGRN, id) => {
  const result = await entityCollectionStatus.fetch(entityGRN);
  return result == null ? void 0 : result[id];
};
const useEntityCollectionStatus = (entityGRN, id) => {
  const { data, refetch, isFetching, isError } = useQuery({
    queryKey: keyFn(entityGRN, id),
    queryFn: () => fetchEntityCollectionStatus(entityGRN, id),
    placeholderData: keepPreviousData
  });
  return {
    data,
    refetch,
    isFetching,
    isError
  };
};
export default useEntityCollectionStatus;
